













































import { Vue, Component, Prop } from "vue-property-decorator";
import { ICustomStylingClass } from "@/components/Globals/types/custom.t";
import CustomContainer from "@/components/Globals/CustomContainer.vue";
import CustomText from "@/components/Globals/CustomText.vue";
import TileSelect from '@/components/Globals/molecule.tileselect.vue';

import sizeSelection from '@/mixins/BuyPanel/SizeSelection';

@Component({
  components: {
    CustomContainer,
    CustomText,
    TileSelect
  },
  mixins: [
    sizeSelection
  ],
  name: "TilesSelection",
})
export default class TilesSelection extends Vue {
  [x: string]: any;

  @Prop()
  buyPanelIsLoading?: boolean;

  @Prop({ default: 'customizer'})
  type!: string;

  @Prop()
  customClass?: ICustomStylingClass[];

  @Prop()
  showSizeTiles?: boolean;

  @Prop()
  showQuantityTiles?: boolean;

}
